import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const LockRedIcon: FC<IconProps> = ({ width = 12, height = 15, ...rest }) => (
  <Icon type="lockRed" width={width} height={height} alt="iconLockRed" ignoreRtl {...rest} />
)
